'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _PubNubMessageSerializer = require('conversations-schema/serializers/PubNubMessageSerializer');

var _ConversationalMessageModel = require('conversations-schema/models/ConversationalMessageModel');

var _ConversationModel = require('conversations-schema/models/ConversationModel');

var _pubNubMessageSelectors = require('conversations-core/selectors/pubNubMessageSelectors');

var _conversationSelectors = require('conversations-core/selectors/conversationSelectors');

var _clientSelectors = require('conversations-core/selectors/clientSelectors');

var _ConversationsActions = require('conversations-core/actions/ConversationsActions');

var _OutgoingMessageActions = require('conversations-core/actions/OutgoingMessageActions');

var _AdminUIActions = require('conversations-core/actions/AdminUIActions');

var _ChatFilterOptions = require('conversations-schema/constants/ChatFilterOptions');

var _ChatFilterOptions2 = _interopRequireDefault(_ChatFilterOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = _defineProperty({}, _ActionTypes2.default.RECEIVED_INCOMING_MESSAGE, function (action, getState, dispatch) {
  var _action$payload = action.payload,
      channel = _action$payload.channel,
      message = _action$payload.message;


  var isAdmin = (0, _clientSelectors.getIsAdmin)(getState());
  var clientRole = (0, _pubNubMessageSelectors.getClientRole)(getState());

  var conversations = (0, _conversationSelectors.getConversations)(getState());
  var conversation = (0, _get2.default)(channel, conversations);

  var visitorPublishingInitialMessage = !isAdmin && (0, _ConversationalMessageModel.isInitialMessage)(message);

  var clientPublishingMessage = (0, _ConversationalMessageModel.isFrom)(clientRole, message) && !(0, _ConversationalMessageModel.isInitialMessage)(message);

  if (visitorPublishingInitialMessage || clientPublishingMessage) {
    dispatch((0, _OutgoingMessageActions.publishOutgoingMessageSuccess)({ channel: channel, message: message }));
    return;
  }

  if ((0, _ConversationModel.containsMessage)(conversation, message)) {
    window.Raven.captureMessage('RECEIVED_DUPLICATE_MESSAGE_FOR_CHANNEL', {
      extra: { message: (0, _PubNubMessageSerializer.serialize)(message), channel: channel }
    });
    return;
  }

  if ((0, _ConversationalMessageModel.isConversationalMessage)(message) && (0, _clientSelectors.getActiveChannel)(getState()) !== channel) {
    dispatch((0, _ConversationsActions.incrementUnseenCount)({ channel: channel }));
  }

  if (isAdmin && (0, _conversationSelectors.getChatFilterSetting)(getState()) !== _ChatFilterOptions2.default.STARTED && (0, _conversationSelectors.getCurrentChannel)(getState()) === channel) {
    dispatch((0, _AdminUIActions.setChatFilter)(_ChatFilterOptions2.default.STARTED));
  }
  dispatch((0, _ConversationsActions.addMessageToConversation)({ channel: channel, message: message }));
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/pubNubHandlers/receiveHandlers.js
// module id = 500
// module chunks = 0